import { useEffect, useState } from "react";
import axios from "axios";
import { buildApiUrl } from "../config/runtime";
import { DEFAULT_SITE_CONTENT } from "../content/defaultSiteContent";

export function useSiteContent() {
  const [content, setContent] = useState(DEFAULT_SITE_CONTENT);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    async function loadContent() {
      setLoading(true);
      try {
        const response = await axios.get(buildApiUrl("/chat/site/content"));
        if (!cancelled && response.data && typeof response.data === "object") {
          setContent(response.data);
          setError(null);
        }
      } catch (err) {
        if (!cancelled) {
          setContent(DEFAULT_SITE_CONTENT);
          setError(err);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    loadContent();

    return () => {
      cancelled = true;
    };
  }, []);

  return { content, loading, error };
}

export function usePaymentCatalog() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    async function loadCatalog() {
      setLoading(true);
      try {
        const response = await axios.get(buildApiUrl("/chat/site/payment-catalog"));
        if (!cancelled) {
          setProducts(Array.isArray(response.data?.products) ? response.data.products : []);
          setError(null);
        }
      } catch (err) {
        if (!cancelled) {
          setProducts([]);
          setError(err);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    loadCatalog();

    return () => {
      cancelled = true;
    };
  }, []);

  return { products, loading, error };
}
